import { TStatusBadge } from '@shared/components/status-badge/status-badge.interface';

export interface IKpiGoalsTableRow {
  current: string;
  currentSortValue: number;
  expected: string;
  expectedSortValue: number;
  id: string;
  kpi: string;
  kpiSortValue: string;
  status: string;
  statusBadge: TStatusBadge | null;
  statusSortValue: number;
}

export enum EKpiGoalsStatusBadge {
  kpiGoalsBelowTarget = 'kpiGoalsBelowTarget',
  kpiGoalsFailed = 'kpiGoalsFailed',
  kpiGoalsPlanned = 'kpiGoalsPlanned',
  kpiGoalsProcessing = 'kpiGoalsProcessing',
  kpiGoalsReached = 'kpiGoalsReached',
  kpiGoalsUnavailable = 'kpiGoalsUnavailable',
  kpiGoalsNotStarted = 'kpiGoalsNotStarted',
  kpiGoalsNotSet = 'kpiGoalsNotSet',
  kpiGoalsHealthy = 'kpiGoalsHealthy',
}
